import React, { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import TopBar from "./page/layout/TopBar";
import Home from "./page/Home/Home";
import Footer from "./page/layout/Footer";

import Wishlist from "./page/Home/Wishlist";
import Cart from "./page/Home/Cart";
import Checkout from "./page/Home/Checkout";
import Contact from "./page/Home/Contact";
import Shop from "./page/Home/Shop";
import Category from "./page/Home/Category";
import ShopDetails from "./page/Home/ShopDetails";
import PayStripe from "./page/Home/PayStripe";
import PayKlarna from "./page/Home/PayKlarna";

import Account from "./page/account/Account";
import Notification from "./page/account/Notification";
import Address from "./page/account/Address";
import Dashboard from "./page/account/Dashboard";
import Order from "./page/account/Order";

import { ToastContainer } from "react-toastify";
import AuthChecker from "./redux/features/authentication/AuthChecker";
import PrivateRoute from "./redux/features/authentication/PrivateRoute"; // Import PrivateRoute
import HeaderFigma from "./page/layout/HeaderFigma";
import FooterFigma from "./page/layout/FooterFigma";
import ShopNewDesign from "./page/Home/productsNewDesign/ShopNewDesign";
import AboutUs from "./FooterPages/AboutUs";
import Faqs from "./FooterPages/Faqs";
import AskQuestions from "./FooterPages/AskQuestions";
import HappyCustomers from "./FooterPages/HappyCustomers";
import TurmsAndCondition from "./FooterPages/TurmsAndCondition";
import RefundPolicies from "./FooterPages/RefundPolicies";
import ReturnPolicies from "./FooterPages/ReturnPolicies";
import ScrollToTop from "./ScrollToTop";
import i18n from "i18next";
import { useSelector } from "react-redux";
import ModalContainer from "./modal/ModalContainer";

function App() {
  const lang = useSelector((state) => state.language.lang);

  function loadDynamicCSS(id, href) {
    // Remove old CSS if exists
    const oldLink = document.getElementById(id);
    if (oldLink) oldLink.remove();

    // Create new CSS link
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.id = id;

    document.head.appendChild(link);
  }

  useEffect(() => {
    const cssId = "dynamic-lang-css";

    const cssFile =
      lang === "de"
        ? "/NewCss/NewDesignFigmaDE.css"
        : "/NewCss/NewDesignFigma.css";

    loadDynamicCSS(cssId, cssFile);
  }, [lang]);

  useEffect(() => {
    console.log("language", lang);
  }, [lang]);

  const location = useLocation();
  const productListRef = useRef(null);

  useEffect(() => {
    if (location.state?.scrollToCarousel) {
      const element = document.getElementById("home-carousel");
      element?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <div>
      <AuthChecker />
      <ScrollToTop />
      {/* <TopBar /> */}
      <HeaderFigma productListRef={productListRef} />
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home productListRef={productListRef} />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/ask-a-questions" element={<AskQuestions />} />
        <Route path="/happy-customers" element={<HappyCustomers />} />
        <Route path="/terms&condition" element={<TurmsAndCondition />} />
        <Route path="/refund-policies" element={<RefundPolicies />} />
        <Route path="/return-policies" element={<ReturnPolicies />} />
        {/* <Route path="/shops" element={<Shop />} /> */}
        <Route path="/shops" element={<ShopNewDesign />} />
        <Route path="/product/:shopId" element={<ShopDetails />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/:categoryId" element={<Category />} />

        {/* Private Routes */}
        <Route
          path="/cart"
          element={
            <PrivateRoute>
              <Cart />
            </PrivateRoute>
          }
        />
        <Route
          path="/wishlist"
          element={
            <PrivateRoute>
              <Wishlist />
            </PrivateRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <PrivateRoute>
              <Checkout />
            </PrivateRoute>
          }
        />
        <Route
          path="/pay-stripe/:order_ids"
          element={
            <PrivateRoute>
              <PayStripe />
            </PrivateRoute>
          }
        />
        <Route
          path="/pay-klarna/:order_ids"
          element={
            <PrivateRoute>
              <PayKlarna />
            </PrivateRoute>
          }
        />
        <Route
          path="/account"
          element={
            <PrivateRoute>
              <Account />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/order"
          element={
            <PrivateRoute>
              <Order />
            </PrivateRoute>
          }
        />
        <Route
          path="/notification"
          element={
            <PrivateRoute>
              <Notification />
            </PrivateRoute>
          }
        />
        <Route
          path="/address"
          element={
            <PrivateRoute>
              <Address />
            </PrivateRoute>
          }
        />
      </Routes>
      <FooterFigma />
      <ModalContainer /> {/* ONLY ONE */}
      {/* <Footer /> */}
    </div>
  );
}

export default App;
